import escapeStringRegexp from 'escape-string-regexp';

// Replacements for properties escapement
const REPLACEMENTS = {
    '\\': '\\\\',
    '*': '\\*',
    '#': '\\#',
    '(': '\\(',
    ')': '\\)',
    '[': '\\[',
    ']': '\\]',
    '`': '\\`',
    ':': '\\_',
    '|': '\\|',
    '"': '\\"',
    "'": "\\'",
};

const REVERSE_REPLACEMENTS = Object.keys(REPLACEMENTS).reduce((obj, key) => {
    obj[REPLACEMENTS[key]] = key;
    return obj;
}, {});

// Build a regexp from a string
function re(str: string): RegExp {
    return new RegExp(escapeStringRegexp(str), 'g');
}

/**
 * Escape a string using a map of replacements.
 */
function escapeWith(replacements: { [input: string]: string }, text: string): string {
    return Object.keys(replacements).reduce(
        (out, key) => out.replace(re(key), replacements[key]),
        text
    );
}

// User-inserted slashes have to be escaped first.
// But they need to be unescaped last as markupit adds slashes itself.
// So first we unescape the slashes combined with something else and end by unescaping the lone-slashes.
export const unescapeTag = (str: string) => escapeWith(REVERSE_REPLACEMENTS, str);
